import { Box, Grid } from "@mui/material";
import React, { useContext } from "react";
import MyContext from "../../../contexts/MyContext";
import { useTranslation } from "react-i18next";
import { MyButton } from "../../../components/my-button/MyButton";

export const Slide3 = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const onContinue = () => {
    myContext.changeActiveSlide(0);
  };
  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 2}>
          <Grid container spacing={3} style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
            <Grid item>
              {context.caseNumber != null && context.caseNumber.trim() != "" && (
                <div dangerouslySetInnerHTML={{ __html: t("thank_you_for_your_application", { casenumber: context.caseNumber }) }} />
              )}
              {(context.caseNumber == null || context.caseNumber.trim() == "") && (
                <div dangerouslySetInnerHTML={{ __html: t("thank_you_for_your_application_without_casenumber", { casenumber: context.caseNumber }) }} />
              )}
            </Grid>
            <Grid item>
              <MyButton className="button primary margin top-0" text={t("submit_another_claim")} onClick={onContinue} />
            </Grid>
          </Grid>
        </div>
      )}
    </MyContext.Consumer>
  );
};
